import type { Pagamento, RegistrarPagamentoCommand } from '@/domain/model/Pagamento';
import type { PagamentoGateway } from '@/application/port/out/PagamentoGateway';
import type {
  ListPagamentosByParcelaUseCase, RegistrarPagamentoManualUseCase,
} from '@/application/port/in/PagamentoUseCase';

export class ListPagamentosByParcela implements ListPagamentosByParcelaUseCase {
  constructor(private readonly gateway: PagamentoGateway) {}
  execute(parcelaId: string): Promise<Pagamento[]> { return this.gateway.listByParcela(parcelaId); }
}

export class RegistrarPagamentoManual implements RegistrarPagamentoManualUseCase {
  constructor(private readonly gateway: PagamentoGateway) {}
  execute(command: RegistrarPagamentoCommand): Promise<Pagamento> { return this.gateway.registrarManual(command); }
}
